import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'
import { Building2 } from 'lucide-react'
import { useAuthStore } from '@store/authStore'

// Where bus companies sign in. Set VITE_PARTNER_PORTAL_URL per environment.
const PARTNER_URL = (import.meta as any).env?.VITE_PARTNER_PORTAL_URL || 'https://daladalasmart.co.tz/partners/login'

/** Operators used to share this admin app. They now have their own portal on the public website. */
export default function PartnerPortalNotice() {
  const logout = useAuthStore((s) => s.logout)
  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center" p={6}>
      <VStack spacing={5} maxW="md" textAlign="center">
        <Box w={14} h={14} borderRadius="2xl" bg="brand.50" color="brand.600" display="flex" alignItems="center" justifyContent="center">
          <Building2 size={26} />
        </Box>
        <Heading size="md">Bus companies have a new home</Heading>
        <Text color="gray.600">
          Your fleet, schedule, crew and earnings now live in the Daladala Smart partner portal. Sign in there with the same email and password.
        </Text>
        <Button as="a" href={PARTNER_URL}>Open the partner portal</Button>
        <Button variant="ghost" size="sm" onClick={logout}>Sign out</Button>
      </VStack>
    </Box>
  )
}
